import 'bootstrap';

import Alert from './modules/alerts'
import Form from './modules/forms'
import Layout from './modules/layout'
import Logger from './modules/logger'
import Login from './modules/login'
import Navigation from './modules/navigation'
import Modals from './modules/modals'
import Plugins from './modules/plugins'
import Progress from './modules/progress'
import Session from './modules/session'
import Utility from './modules/utility'
import VideoPlayer from './modules/video'

window.Alert = Alert;
window.Form = Form;
window.Navigation = Navigation;
window.Plugins = Plugins;
window.Progress = Progress;
window.Layout = Layout;
window.Logger = Logger;
window.Login = Login;
window.Modals = Modals;
window.Session = Session;
window.Utility = Utility;
window.VideoPlayer = VideoPlayer;

$(function(){
    Logger.init();
    Alert.init();
    Form.init();
    Navigation.init();
    Plugins.init();
    Layout.init();
    Login.init();
    Modals.init();
    Plugins.init();
    Progress.init();
    Session.init();
    Utility.init();
    VideoPlayer.init();
});
